import { cx } from '@twind/core';

export default function MiniSelectionCard({
  children,
  selected,
  className,
  ...props
}: {
  children: React.ReactNode;
  selected?: boolean;
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const borderColor = selected ? 'border-[#1E1E1E]' : 'border-[#E1E1E1]';
  return (
    <button
      className={cx(`px-3 py-2 rounded-lg text-sm border ${borderColor}`, className)}
      {...props}
    >
      {children}
    </button>
  );
}
